import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  prepaid_interest: Yup.number().required(),
  secondary_market_accrued_interest: Yup.number().required(),
  sales_adjustments_and_or_penalties: Yup.number().required(),
  interest_income: Yup.number().required(),
  origination_proceeds: Yup.number().required(),
  other_revenue: Yup.number().required(),
  curtailments: Yup.number().required(),
  additional_fees: Yup.number().required(),
  hedging_gains: Yup.number().required(),
});
